import React from 'react';
import useColors from 'hooks/useColors';
import IconStatusCancelled from './icons/status/IconStatusCancelled';
import IconStatusDone from './icons/status/IconStatusDone';
import IconStatusPaused from './icons/status/IconStatusPaused';
import IconStatusPending from './icons/status/IconStatusPending';
import IconStatusReceived from './icons/status/IconStatusReceived';
import IconStatusSent from './icons/status/IconStatusSent';
const StatusIcon = ({ state, width, height }) => {
    const colors = useColors();
    switch (state) {
        case 'cancelled-red':
            return (<IconStatusCancelled width={width} height={height} colorKey="statusNegative"/>);
        case 'cancelled-gray':
            return (<IconStatusCancelled width={width} height={height} colorKey="statusOffline"/>);
        case 'paused':
            return (<IconStatusPaused width={width} height={height} color={colors.elements.statusOffline} bgColor={colors.cards.onDark}/>);
        case 'in-progress':
            return (<IconStatusPending width={width} height={height} color={colors.cards.onDark} bgColor={colors.elements.statusInformational}/>);
        case 'done':
            return (<IconStatusDone width={width} height={height} colorKey="statusPositive"/>);
        case 'sent':
            return (<IconStatusSent width={width} height={height} colorKey="statusNegative"/>);
        case 'received':
            return (<IconStatusReceived width={width} height={height} colorKey="statusPositive"/>);
        default: {
            return null;
        }
    }
};
export default StatusIcon;
